import styled from "@emotion/styled";
import { ProgressBar } from "react-aria-components";
import { motion } from "motion/react";

export const VIEW_BOX_SIZE = 14;
export const STROKE_WIDTH = 2.5;
export const RADIUS = VIEW_BOX_SIZE / 2 - STROKE_WIDTH / 2;
export const CENTER = VIEW_BOX_SIZE / 2;
export const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

export const StyledProgressBar = styled(ProgressBar)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 1.16667em;
  height: 1.16667em;
  vertical-align: middle;
`;

export const StyledSvg = styled.svg`
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
`;

export const StyledCircleBackground = styled.circle`
  fill: none;
  stroke: ${({ theme }) => theme.colors.icon.placeholder};
  stroke-width: ${STROKE_WIDTH};
`;

export const StyledCircleProgress = styled(motion.circle)<{
  $animated: boolean;
}>`
  fill: none;
  stroke: ${({ theme }) => theme.colors.icon.primary};
  stroke-width: ${STROKE_WIDTH};
  stroke-linecap: round;
`;
